import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
class ReportViewer extends Component {
 
  constructor(props){
    super(props);

    this.state={

    }
  }
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <h2 className="mb-0 mt-5">Report Viewer</h2>
          <hr className="mt-2 mb-4" />
          <div className="card card-icon mb-4">
            <div className="row no-gutters">
              <div className="col-auto card-icon-aside bg-primary">
                <button
                  className="btn btn-blue"
                  onClick={() => {
                    this.props.history.push("/dataSourceSettings");
                  }}
                >
                  + New Source
                </button>
              </div>
              <div className="col">
                <div className="card-body py-5">
                  {this.state.DataSources && this.state.DataSources.map((source, idx) => {
                    return (
                      <React.Fragment key={source.DataSource_ID}>
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <div
                              className={this.getSourceBadge(
                                source.DataSource_Type_ID
                              )}
                            >
                              {source.DataSource_Type_Name}
                            </div>
                            <div className="ml-4">
                              <div>
                                <Link
                                  to={{
                                    pathname: "/dataSourceSettings/",
                                    DataSource_ID: source.DataSource_ID,
                                    DataSource_Type_ID:
                                      source.DataSource_Type_ID,
                                  }}
                                >
                                  {source.Description}
                                </Link>
                              </div>
                              {/* <div className="text-xs text-muted">
                                {source.Connection_String}
                              </div> */}
                            </div>
                          </div>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() =>
                              this.handleRemove(source.DataSource_ID)
                            }
                          >
                            Delete
                          </button>
                        </div>
                        {idx !== this.state.DataSources.length - 1 && <hr />}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default withRouter(ReportViewer);
